module.exports = __webpack_public_path__ + "img/cv.6e4a5457.jpg";